<template>
  <form @submit="handleChangePassword($event)">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col">
            <div class="form-group position-relative">
              <label for="firstName"
                >New Password
                <span
                  class="invalid"
                  v-if="veeErrors.first('password') && !newPassword"
                >
                  - Field is required</span
                >
                <span
                  class="invalid"
                  v-else-if="veeErrors.first('password') && newPassword"
                >
                  - {{ veeErrors.first("password") }}</span
                >
              </label>
              <input
                :type="type"
                name="password"
                v-model="newPassword"
                placeholder="Enter new password"
                class="form-control"
                v-validate="'required|verify_input|min:6|max:100'"
              />
              <img
                @click="handleTogglePassword"
                class="visibility__toggle"
                src="~@/assets/media/icons/visibility.svg"
                alt="visiblity icon"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group text-right mb-0">
              <ActionButton
                label="Change"
                :type="'submit'"
                :theme="{ primary, secondary, event, danger }"
                style="width: auto; margin-left: auto; margin-bottom: 0;margin-top: 10px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import { socketSender } from "@/helpers/socket";
import { Validator } from "vee-validate";

export default {
  name: "AddNewMember",
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      newPassword: null,
      editMemberId: this.singleRecord.id,
      btnLabel: "Change",
      activePallete: {
        pale: "#E1FAF4",
        main: "#51B67E",
        event: "#00BC8A"
      },
      type: "password",
      currentUser:
        this.$store.getters.getUser.firstName +
        " " +
        this.$store.getters.getUser.lastName
    };
  },
  components: {
    ActionButton
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  mounted() {
    Validator.extend("verify_input", {
      getMessage: "Password format is invalid",
      validate: value => {
        var regex = new RegExp(
          /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/
        );
        return !regex.test(value);
      }
    });
  },
  methods: {
    async handleChangePassword(event) {
      event.preventDefault();
      const isFormValid = await this.$validator.validateAll();
      if (!isFormValid) {
        throw new Error("Unable to submit form. Try again.");
      }
      if (this.newPassword != null && this.newPassword != "") {
        let form = {
          password: this.newPassword
        };
        /**
         * SOCKET: Update user password
         */
        let logContent = `${this.currentUser} changed the password of ${this.singleRecord.firstName} ${this.singleRecord.lastName} to ${this.newPassword} `;
        socketSender("userUpdate", logContent);
        let data = { form: form, id: this.editMemberId };
        await this.$store.dispatch("patchMember", data);
        await this.$toastr.success("Your changes are saved", "Success");
        this.$emit("close");
      } else {
        this.newPassword = "";
        await this.$toastr.warning("Please enter the new password", "Warning");
      }
    },
    handleTogglePassword() {
      this.type = this.type === "password" ? "text" : "password";
    }
  }
};
</script>

<style lang="scss" scoped>
.visibility__toggle {
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 15px;
  top: 40px;
}
</style>
